import { isMaldivesCharterBundleOffer } from 'lib/charterFlights/charterBundleOfferPageUtils'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'

/**
 * Flash offers with multiple stay lengths. The length-of-stay carousel replaces the duration
 * dropdown, including before check-in and check-out are selected. Single-length offers keep
 * the existing calendar. Charter identity uses the existing bundle classifier, with flights
 * optional so hotel-only offers still match, plus the page route which stays set when the
 * bundle switch is off.
 */
export function isFlashOfferLosCalendarEligible(
  offer: App.AnyOffer | undefined,
  charterBundleRoute?: App.CharterBundleRoute,
): boolean {
  return isFlashHotelOffer(offer) &&
    offer.packages.some(pkg => pkg.duration !== offer.packages[0]?.duration) &&
    !charterBundleRoute &&
    !isMaldivesCharterBundleOffer(offer, true, { requireFlightsEnabled: false })
}
